import { useContext } from "react";
import { DataTableContext } from "../../../contexts";
import { DataTableServerSideContext } from "../../../contexts/dataTableServerSideContext";

export const useDataTableContext = () => {
	const serverSideContext = useContext(DataTableServerSideContext);
	const clientSideContext = useContext(DataTableContext);

	const hasServerSideContext =
		serverSideContext && Object.keys(serverSideContext).length > 0;

	return hasServerSideContext ? serverSideContext : clientSideContext;
};
